import { toCamel, toKebab } from '@/components/utils/core/word';

/**
 * Checks if the object has prop as its own property
 * @param {Object} object
 * @param {string} prop
 * @returns {boolean}
 */
export const has = (object, prop) => Object.prototype.hasOwnProperty.call(object, prop);

export const flattenParams = object => {
  return Object.entries(object).reduce((acc, [key, val]) => {
    if (typeof val === 'object' && !Array.isArray(val) && val !== null) {
      const nestedObject = Object.entries(val).reduce((innerAcc, [nestedKey, nestedVal]) => {
        return { ...innerAcc, [`${key}[${nestedKey}]`]: nestedVal };
      }, {});
      return { ...acc, ...nestedObject };
    }
    return { ...acc, [key]: val };
  }, {});
};

export const flattenParamsDeep = (data, parentKey, acct = {}) => {
  if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
    Object.keys(data).forEach(key => {
      flattenParamsDeep(data[key], parentKey ? `${parentKey}[${key}]` : key, acct);
    });
  } else {
    acct[parentKey] = data == null ? '' : data;
  }
  return acct;
};

const arrayOfIdsRegex = /(\w*_ids)\[\d\]$/;
const matchArrayOfIds = key => key.match(arrayOfIdsRegex);

export const createFormData = data => {
  const formData = new FormData();
  Object.entries(data).forEach(([key, val]) => {
    const match = matchArrayOfIds(key);
    if (match) {
      const [, model] = match;
      formData.append(`${model}[]`, val);
      return;
    }

    formData.set(key, val);
  });
  return formData;
};

export const cloneDeep = object => JSON.parse(JSON.stringify(object));

export const filterByKey = (obj, blacklistedKeys) => {
  return Object.entries(obj).reduce((acc, [key, val]) => {
    if (blacklistedKeys.includes(key)) {
      return { ...acc };
    }
    return { ...acc, [key]: val };
  }, {});
};

export function transformObjectKeys(transformFunc) {
  return function transformator(data) {
    if (data && typeof data === 'object' && !(data instanceof Date)) {
      if (Array.isArray(data)) {
        return data.map(transformator);
      } else {
        return Object.entries(data).reduce((result, [key, val]) => {
          result[transformFunc(key)] = transformator(val);
          return result;
        }, {});
      }
    } else {
      return data;
    }
  };
}

export const pick = (object, keys) => {
  return keys.reduce((result, path) => {
    if (has(object, path)) result[path] = object[path];

    return result;
  }, {});
};

export const isEmpty = obj => {
  if (!obj) return true;

  return !Object.keys(obj).length && obj.constructor === Object;
};

export const omit = (object, keys) => {
  const result = Object.assign({}, object);

  keys.forEach(key => {
    Reflect.deleteProperty(result, key);
  });

  return result;
};

export const toCamelTransformator = transformObjectKeys(toCamel);

export const toKebabTransformator = transformObjectKeys(toKebab);
